module.exports = __webpack_public_path__ + "static/media/contact.9afc27a3.png";